/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdContractsContractIdBids200Ok
 */
export interface GetCorporationsCorporationIdContractsContractIdBids200Ok {
    /**
     * The amount bid, in ISK
     * @type {number}
     * @memberof GetCorporationsCorporationIdContractsContractIdBids200Ok
     */
    amount: number;
    /**
     * Unique ID for the bid
     * @type {number}
     * @memberof GetCorporationsCorporationIdContractsContractIdBids200Ok
     */
    bidId: number;
    /**
     * Character ID of the bidder
     * @type {number}
     * @memberof GetCorporationsCorporationIdContractsContractIdBids200Ok
     */
    bidderId: number;
    /**
     * Datetime when the bid was placed
     * @type {Date}
     * @memberof GetCorporationsCorporationIdContractsContractIdBids200Ok
     */
    dateBid: Date;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdContractsContractIdBids200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdContractsContractIdBids200Ok(value: object): value is GetCorporationsCorporationIdContractsContractIdBids200Ok {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('bidId' in value) || value['bidId'] === undefined) return false;
    if (!('bidderId' in value) || value['bidderId'] === undefined) return false;
    if (!('dateBid' in value) || value['dateBid'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdContractsContractIdBids200OkFromJSON(json: any): GetCorporationsCorporationIdContractsContractIdBids200Ok {
    return GetCorporationsCorporationIdContractsContractIdBids200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdContractsContractIdBids200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdContractsContractIdBids200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'bidId': json['bid_id'],
        'bidderId': json['bidder_id'],
        'dateBid': (new Date(json['date_bid'])),
    };
}

export function GetCorporationsCorporationIdContractsContractIdBids200OkToJSON(json: any): GetCorporationsCorporationIdContractsContractIdBids200Ok {
    return GetCorporationsCorporationIdContractsContractIdBids200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdContractsContractIdBids200OkToJSONTyped(value?: GetCorporationsCorporationIdContractsContractIdBids200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'bid_id': value['bidId'],
        'bidder_id': value['bidderId'],
        'date_bid': ((value['dateBid']).toISOString()),
    };
}

